import { Component, OnInit, Input, OnDestroy, ViewChild, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../../Library/BaseComponent';
import { MasterDataService } from '../../Services/MasterDataService';
import { ActivatedRoute, Router } from '@angular/router';
import { CallStatuses, JobOperationActions, MasterConstants, DeviceTypes } from '../../Models/EnumModels';
import { GuestLookup, ListResponse } from '../../Models/ResponseModels';
import * as _ from 'lodash';
import * as moment from 'moment';
import { MessagingService } from '../../Services/MessagingService';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { MessageDetail } from '../MessageDetail/MessageDetail';
import { MessageSearch, ListRequest } from '../../Models/RequestModels';
import { GenericMaster } from '../../Models/GlobalEntities';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { AppSettings } from '../../Library/AppSettings';

@Component({
    selector: 'Inbox',
    templateUrl: './Inbox.html'
})

export class Inbox extends BaseComponent implements OnInit, OnDestroy {
    @ViewChild('messageDetail') messageDetail: MessageDetail;

    Model: ListResponse;
    RequestModel: MessageSearch = new MessageSearch();

    DateFormat: string;

    SelectedProperties: Array<number> = [];
    lstEventMaster: GenericMaster[];
    AppSettings = AppSettings;

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, public _messagingService: MessagingService) {
        super(translate, toastr, route, router, masterService);
    }

    ngOnDestroy(): void {

    }

    ngOnInit(): void {
        this.lstEventMaster = this.masterService.GetEventMaster(this.masterService.LoggedInUserData.PropertyId);
        this.RequestModel = new MessageSearch();
        this.RequestModel.SetDefaults();

        this.DateFormat = this.masterService.GetPropertyDateFormat(null);

        this.SetSearchProperties();

        //this.onMessageCacheChanged();

        this._messagingService.MessageCacheChanged.pipe(untilDestroyed(this)).subscribe((data) => {
            this.onMessageCacheChanged(data);
        });

        this.SetData();
    }

    onMessageCacheChanged(data): void {
        if (this.Model == null || this.Model.Result == null || this.Model.Result.length == 0)
            return;

        if (data == undefined || data == null) {
            let cache = _.cloneDeep(this._messagingService.MessageCache);
            cache.map(row => {
                let idx = this.Model.Result.findIndex(a => a.MessageId == row.MessageId);
                if (idx >= 0) {
                    this.Model.Result[idx] = row;
                }
            });
        }
        else {
            let idx = this.Model.Result.findIndex(a => a.MessageId == data.MessageId);
            if (idx >= 0) {
                this.Model.Result[idx] = data;
            }
        }

        //this.Model = this._messagingService.MessageCache;
    }

    onMessageClick(Data:any): void {
        if (Data.IsRead == false)
            this._messagingService.Message_MarkAsRead(Data.MessageId);

        this.messageDetail.Open(Data);
    }

    onPropertyOpened(val: any): void {
        if (val == true)
            this.SelectedProperties = _.cloneDeep(this.RequestModel.Properties);
    }

    idxPropSelectedDropDown(PropertyId: number): number {
        return this.SelectedProperties.findIndex(a => a == PropertyId);
    }

    onPropertySelected(PropertyId: number, eventData: any): void {
        let idx = this.idxPropSelectedDropDown(PropertyId);

        if (eventData.target.checked) {
            if (idx >= 0)
                return;

            this.SelectedProperties.push(PropertyId);
        }
        else {
            if (idx >= 0) {
                this.SelectedProperties.splice(idx, 1);
            }
        }
    }

    isPropSelected(id: number): boolean {
        if (this.RequestModel == null || this.RequestModel.Properties == null)
            return false;

        return (this.RequestModel.Properties.findIndex(a => a == id) >= 0);
    }

    SetSearchProperties(): void {
        if (this.SelectedProperties == null || this.SelectedProperties.length == 0) {
            this.masterService.LoggedInUserData.Properties.map(row => {
                this.SelectedProperties.push(row.PropertyId);
            });
        }

        this.RequestModel.Properties = _.cloneDeep(this.SelectedProperties);

        //for (let i = 0; i < this.masterService.LoggedInUserData.Properties.length; i++) {
        //    this.RequestModel.Properties.push(this.masterService.LoggedInUserData.Properties[i].PropertyId);
        //}
    }

    onPropertyChange(): void {
        //this.RequestModel.PropertyId = PropertyId;
        if (this.SelectedProperties.length == 0)
            this.SetSearchProperties();

        this.RequestModel.Properties = _.cloneDeep(this.SelectedProperties);

        this.SetData();
    }

    onPageChange(): void {
        this.SetData();
    }

    SetData(): void {
        this.SubmitStart();

        if (this.RequestModel.EventId <= 0) {
            this.RequestModel.EventId = null;
        }

        this.RequestModel.DeviceTypeId = DeviceTypes.PC;

        this._messagingService.Message_Search(this.RequestModel).then(data => {
            this.Model = data;
            this.SubmitEnd();
        }).catch(err => {
            //console.info(err);
            this.SubmitEnd();
        });
    }
}
